export const enum PictureTextKind {
  TwoThirdsPictureText = 'two_thirds_picture_text',
  HalfPictureText = 'half_picture_text',
  DoublePictureText = 'double_picture_text',
  FullWidthPicture = 'full_width_picture',
}
